import React from "react";
import PropTypes from "prop-types";
import Img from "gatsby-image";
import useWindowSize from "../../_Common/useWindowSize";
import { MOBILE_BREAKPOINT } from "../../_Common/constants";

const Image = ({ image, imageMobile }) => {
  const size = useWindowSize();

  const fluidImage =
    size.width < MOBILE_BREAKPOINT && imageMobile != null ? imageMobile : image;

  return <Img fluid={fluidImage.fluid} />;
};

Image.propTypes = {
  image: PropTypes.object.isRequired,
  mobileImage: PropTypes.object
};

export default Image;
